import * as React from 'react'
  /* @jsx mdx */
import { mdx } from '@mdx-js/react';
/* @jsxRuntime classic */

/* @jsx mdx */

import { Note } from '../..';
export const _frontmatter = {
  "title": "Forms"
};
const layoutProps = {
  _frontmatter
};
const MDXLayout = "wrapper";
export default function MDXContent({
  components,
  ...props
}) {
  return <MDXLayout {...layoutProps} {...props} components={components} mdxType="MDXLayout">

    <h1 {...{
      "id": "forms"
    }}>{`Forms`}</h1>
    <p>{`Several primitive components are included for building accessible forms.`}</p>
    <pre><code parentName="pre" {...{
        "className": "language-js"
      }}>{`import {
  Label,
  Input,
  Select,
  Textarea,
  Radio,
  Checkbox,
  Slider,
} from 'theme-ui'
`}</code></pre>
    <pre><code parentName="pre" {...{
        "className": "language-jsx",
        "metastring": "live=true",
        "live": "true"
      }}>{`<Box as="form" onSubmit={(e) => e.preventDefault()}>
  <Label htmlFor="username">Username</Label>
  <Input name="username" id="username" mb={3} />
  <Label htmlFor="password">Password</Label>
  <Input type="password" name="password" id="password" mb={3} />
  <Box>
    <Label mb={3}>
      <Checkbox />
      Remember me
    </Label>
  </Box>
  <Label htmlFor="sound">Sound</Label>
  <Select name="sound" id="sound" mb={3}>
    <option>Beep</option>
    <option>Boop</option>
    <option>Blip</option>
  </Select>
  <Label htmlFor="comment">Comment</Label>
  <Textarea name="comment" id="comment" rows={6} mb={3} />
  <Flex mb={3}>
    <Label>
      <Radio name="letter" /> Alpha
    </Label>
    <Label>
      <Radio name="letter" /> Bravo
    </Label>
    <Label>
      <Radio name="letter" /> Charlie
    </Label>
  </Flex>
  <Label>Slider</Label>
  <Slider mb={3} />
  <Button>Submit</Button>
</Box>
`}</code></pre>
    <Note mdxType="Note">
      <p><strong parentName="p">{`Tip:`}</strong>{`
Each form field needs to include a `}<inlineCode parentName="p">{`<label>`}</inlineCode>{` element with an `}<inlineCode parentName="p">{`htmlFor`}</inlineCode>{` prop that matches its field.
The entire form should be wrapped in a `}<inlineCode parentName="p">{`<form>`}</inlineCode>{` element.`}</p>
    </Note>
    <h2 {...{
      "id": "theming"
    }}>{`Theming`}</h2>
    <p>{`Many of the included form components (e.g. Checkbox, Radio, Slider) use 3 colors for their default appearance:`}</p>
    <ul>
      <li parentName="ul"><inlineCode parentName="li">{`gray`}</inlineCode>{`, for the default state`}</li>
      <li parentName="ul"><inlineCode parentName="li">{`primary`}</inlineCode>{`, for the active state`}</li>
      <li parentName="ul"><inlineCode parentName="li">{`highlight`}</inlineCode>{`, for the focus outline`}</li>
    </ul>
    <p>{`If you’re only looking to change the colors, providing custom values for these colors in `}<inlineCode parentName="p">{`theme.colors`}</inlineCode>{` is the easiest path.`}</p>
    <h3 {...{
      "id": "further-customization"
    }}>{`Further customization`}</h3>
    <p>{`Add styles for form elements in the `}<inlineCode parentName="p">{`theme.forms`}</inlineCode>{` object.`}</p>
    <pre><code parentName="pre" {...{
        "className": "language-js"
      }}>{`// example theme
{
  forms: {
    label: {
      fontSize: 1,
      fontWeight: 'bold',
    },
    input: {
      borderColor: 'gray',
      '&:focus': {
        borderColor: 'primary',
        boxShadow: t => \`0 0 0 2px \${t.colors.primary}\`,
        outline: 'none',
      },
    },
    select: {
      borderColor: 'gray',
      '&:focus': {
        borderColor: 'primary',
        boxShadow: t => \`0 0 0 2px \${t.colors.primary}\`,
        outline: 'none',
      },
    },
    textarea: {
      borderColor: 'gray',
      '&:focus': {
        borderColor: 'primary',
        boxShadow: t => \`0 0 0 2px \${t.colors.primary}\`,
        outline: 'none',
      },
    },
    slider: {
      bg: 'muted',
    },
  },
}
`}</code></pre>

    </MDXLayout>;
}
;
MDXContent.isMDXComponent = true;
      